mutation InvoiceSigningDelete($input: InvoiceSigningDeleteInput!) {
  invoiceSigningDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
